import React from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

interface AuthLayoutProps {
    maxWidth?: 'xs' | 'sm';
    children: React.ReactNode;
}

// Shared centering wrapper for every full-screen auth-flow page (Login,
// Signup, RequestSentScreen). Replaces the old `height: 100vh` + no-overflow
// div each of them used to hand-roll, which silently clipped the top of the
// Signup form (many fields) on shorter viewports instead of scrolling.
export default function AuthLayout({ maxWidth = 'sm', children }: AuthLayoutProps) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', minHeight: '100vh', overflowY: 'auto' }}>
            <Container maxWidth={maxWidth} sx={{ alignSelf: 'center', py: 5 }}>
                <Paper elevation={3} sx={{ p: { xs: 3, sm: 5 }, borderRadius: 3 }}>
                    {children}
                </Paper>
            </Container>
        </div>
    );
}
